import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/product_categories/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/product_categories/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editType(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/product_categories", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteType(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/product_categories", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
